

export default class Class {
  constructor(audio = null, categories = [], description = '', duration = 0, equipment = [], exercisevideos = [], id = null, image = null, intensity_level = null, musclegroup = [], picture = "", published = false, sets = [], tags = [], template = null, title = '',trainer = null, video = null, premium_required = false, is_dc = null) {
    this.audio = audio;
    this.categories = categories;
    this.description = description;
    this.duration = duration;
    this.equipment = equipment;
    this.exercisevideos = exercisevideos;
    this.id = id;
    this.image = image;
    this.intensity_level = intensity_level;
    this.premium_required = premium_required;
    this.musclegroup = musclegroup;
    this.picture = picture;
    this.published = published;
    this.sets = sets;
    this.tags = tags;
    this.template = template;
    this.title = title;
    // this.trainer = trainer;
    this.video = video;
    this.is_dc = is_dc;
  }
}
